export const months = [
    {key: "01", name: "January"},
    {key: "02", name: "February"},
    {key: "03", name: "March"},
    {key: "04", name: "April"},
    {key: "05", name: "May"},
    {key: "06", name: "June"},
    {key: "07", name: "July"},
    {key: "08", name: "August"},
    {key: "09", name: "September"},
    {key: "10", name: "October"}, 
    {key: "11", name: "November"},
    {key: "12", name: "December"} 
    ]

export const years = [ 
    "2026"
]

export const service = [
    {key: "none", name: "--- Select Service Center ---"},
    {key: "east" , name: "East Service Center (CT, DE, DC, ME, MD, MA, NH, NJ, NY, PA, RI, VT, VA, WV)" },
    {key: "mid", name: "Midwest Service Center (IL, IN, IA, KS, MI, MN, MO, NE, OH, WI)" },
    {key: "south", name: "South Service Center (AL, AR, FL, GA, KY, LA, MS, NC, OK, SC, TN)" },
    {key: "west", name: "West Service Center (AK, AZ, CA, CO, HI, ID, MT, NV, NM, ND, OR, SD, TX, UT, WA, WY)" },
    {key: "all", name: "All Service Centers"},
]

  // Dropdown options for Monthly Convictions
export const monthlyConvictionReports = [
    { key: "conviction_report", name: "FCWD Monthly Conviction Report" },
    { key: "conviction_worksheet", name: "FCWD Monthly Conviction Worksheet" },
    { key: "fh_detail", name: "FH FCWD Monthly Detail Report" },
    {key: "east" , name: "East Service Center (CT, DE, DC, ME, MD, MA, NH, NJ, NY, PA, RI, VT, VA, WV)" },
    {key: "mid", name: "Midwest Service Center (IL, IN, IA, KS, MI, MN, MO, NE, OH, WI)" },
    {key: "south", name: "South Service Center (AL, AR, FL, GA, KY, LA, MS, NC, OK, SC, TN)" },
    {key: "west", name: "West Service Center (AK, AZ, CA, CO, HI, ID, MT, NV, NM, ND, OR, SD, TX, UT, WA, WY)" },
];

  // Dropdown options for Monthly Withdrawals
export const monthlyWithdrawalReports = [
    { key: "withdrawal_report", name: "FCWD Monthly Withdrawal Report" },
    { key: "withdrawal_worksheet", name: "FCWD Monthly Withdrawal Worksheet" },
    { key: "timeliness", name: "FCWD Monthly Timeliness Report" },
];


